// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bGkvjyM667gORoj0bkpP{flex-direction:column;flex:1;justify-content:center;width:100%;max-width:628px;margin:0 auto;display:flex}.bGkvjyM667gORoj0bkpP .kiLFkPd0QJF6t1JtpmPE{flex-direction:row;justify-content:center;gap:8px;display:flex}.bGkvjyM667gORoj0bkpP .cctTYvCF1gMGZfEZ8Mnh{text-align:center;flex-direction:column;display:flex}.bGkvjyM667gORoj0bkpP .KJ7NicQ2co8OF4orJdi3{border-radius:16px;align-items:flex-end;margin-bottom:40px;display:flex;overflow:hidden}.bGkvjyM667gORoj0bkpP .KJ7NicQ2co8OF4orJdi3 img{width:100%;height:auto;display:block}.oCzAItgNilMqXQB4B4Xf{width:148px}.ifOMR14otm4HzBOawxOb{width:148px;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `bGkvjyM667gORoj0bkpP`,
	"actions": `kiLFkPd0QJF6t1JtpmPE`,
	"title": `cctTYvCF1gMGZfEZ8Mnh`,
	"titlePreview": `KJ7NicQ2co8OF4orJdi3`,
	"createButton": `oCzAItgNilMqXQB4B4Xf`,
	"guideButton": `ifOMR14otm4HzBOawxOb`
};
export default ___CSS_LOADER_EXPORT___;
